import * as http from './base-api'
import * as querystring  from 'querystring'


/**
 * 대쉬보드 데이터 조회 (관리자)
 *
 * @param params
 * @returns {*}
 */
export const retrieveDashboardData = (params) => {
   return http.get(`/cms/dashboard?${querystring.stringify(params)}`)
}
